import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages/Home.css';

function Home() {
  const featuredServices = [
    {
      title: 'Planting',
      description: 'Beautiful garden plantings that enhance your outdoor space',
      image: '/images/flowers.jpeg'
    },
    {
      title: 'Fence Installation',
      description: 'Durable and attractive fencing solutions for privacy and security',
      image: '/images/fence.jpeg'
    },
    {
      title: 'Decking',
      description: 'Custom-built decks for entertaining and relaxation',
      image: '/images/deck.jpeg'
    }
  ];

  const portfolioProjects = [
    {
      image: '/images/flower1.jpeg',
      title: 'Garden Planting',
      category: 'Planting'
    },
    {
      image: '/images/flower2.jpeg',
      title: 'Flower Garden',
      category: 'Planting'
    },
    {
      image: '/images/grass.jpeg',
      title: 'Lawn Maintenance',
      category: 'Maintenance'
    },
    {
      image: '/images/grass1.jpeg',
      title: 'Grass Care',
      category: 'Maintenance'
    },
    {
      image: '/images/patios.jpeg',
      title: 'Patio Installation',
      category: 'Landscaping'
    },
    {
      image: '/images/fence1.jpeg',
      title: 'Fence Installation',
      category: 'Fencing'
    },
    {
      image: '/images/maintenance.jpeg',
      title: 'Property Maintenance',
      category: 'Maintenance'
    },
    {
      image: '/images/fence2.jpeg',
      title: 'Fence Design',
      category: 'Fencing'
    },
    {
      image: '/images/grass installation.jpeg',
      title: 'Grass Installation',
      category: 'Maintenance'
    }
  ];

  return (
    <div className="home">
      <section className="hero" style={{backgroundImage: 'url(/images/grass.jpeg)'}}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Transform Your Outdoor Space</h1>
          <p>Professional landscaping services in your area</p>
          <Link to="/contact" className="cta-button">
            Get a Free Quote
          </Link>
          <div className="hero-contact">
            <a href="tel:4153054327">(415) 305-4327</a>
            <span className="divider">|</span>
            <a href="mailto:hzlandscapingmarin@gmail.com">hzlandscapingmarin@gmail.com</a>
          </div>
        </div>
      </section>

      <section className="featured-services">
        <div className="container">
          <h2>Our Services</h2>
          <div className="services-grid">
            {featuredServices.map((service, index) => (
              <div key={index} className="service-card-image">
                <img src={service.image} alt={service.title} />
                <div className="service-overlay">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="view-all-link">
            <Link to="/services" className="link-button">
              View All Services →
            </Link>
          </div>
        </div>
      </section>

      <section className="portfolio">
        <div className="container">
          <h2>Our Recent Projects</h2>
          <p className="portfolio-subtitle">Check out our latest landscaping transformations</p>
          <div className="portfolio-grid">
            {portfolioProjects.map((project, index) => (
              <div key={index} className="portfolio-item">
                <img src={project.image} alt={project.title} />
                <div className="portfolio-info">
                  <h3>{project.title}</h3>
                  <p>{project.category}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-preview">
        <div className="container">
          <h2>Why Choose HZ Landscaping?</h2>
          <div className="preview-content">
            <div className="preview-item">
              <h3>Expert Team</h3>
              <p>Years of experience in landscaping and outdoor design</p>
            </div>
            <div className="preview-item">
              <h3>Quality Work</h3>
              <p>We take pride in delivering exceptional results every time</p>
            </div>
            <div className="preview-item">
              <h3>Reliable Service</h3>
              <p>On-time, professional service you can count on</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
